// Tool landing pages published in English only.
//
// They have no entry in src/data/i18n/toolLandingPages.<lang>.js, so the
// prerender, the sitemap and the page's hreflang list only the English URL.
// localeRouting.js reads this list so that internal links, the entry
// middleware and the client language detection keep every visitor on that
// English URL instead of a /<lang>/ path that is never prerendered, and
// getToolLandingPageByPath does not serve the page under a locale prefix.
//
// This module has no imports on purpose: localeRouting.js and
// toolLandingPages.js both read it, and toolLandingPages.js already imports
// localeRouting.js.
export const ENGLISH_ONLY_TOOL_LANDING_SLUGS = Object.freeze([
  'adobe-stock-metadata-generator'
]);

export const ENGLISH_ONLY_TOOL_LANDING_PATHS = Object.freeze(
  ENGLISH_ONLY_TOOL_LANDING_SLUGS.map((slug) => `/${slug}`)
);

export const isEnglishOnlyToolLandingSlug = (slug = '') => (
  ENGLISH_ONLY_TOOL_LANDING_SLUGS.includes(String(slug || '').trim().toLowerCase())
);
